import {defineStyle, defineStyleConfig} from '@chakra-ui/styled-system'

import borders from '../foundations/borders'
import colors from '../foundations/colors'
import size from '../foundations/sizes'
import spacing from '../foundations/space'
import typography from '../foundations/typography'

const baseStyle = defineStyle({
  borderRadius: borders.radii['2xs'],
  direction: 'horizontal',
  alignItems: ['middle', 'center'],
  resize: 'horizontal',
  itemSpacing: spacing['5xs'],
  ...typography.textStyles.subheading.small,
})

const primary = defineStyle({
  color: colors.text['contrast-primary'],
  backgroundColor: colors.background.brand,
  _hover: {
    backgroundColor: colors.background['brand-hover'],
  },
  _active: {
    backgroundColor: colors.background['brand-active'],
  },
})

const secondary = defineStyle({
  color: colors.text.secondary,
  backgroundColor: colors.background.tertiary,
  _hover: {
    backgroundColor: colors.background['tertiary-hover'],
  },
  _active: {
    backgroundColor: colors.background['tertiary-active'],
  },
})

const hollow = defineStyle({
  borderWidth: 0,
  color: colors.text.secondary,
  _hover: {
    backgroundColor: colors.background['tertiary-hover'],
  },
  _active: {
    backgroundColor: colors.background['tertiary-active'],
  },
})

const outline = defineStyle({
  color: colors.text.secondary,
  borderStyle: colors.border.secondary,
  _hover: {
    backgroundColor: colors.background['tertiary-hover'],
  },
  _active: {
    backgroundColor: colors.background['tertiary-active'],
  },
})

const distractive = defineStyle({
  backgroundColor: colors.background.error,
  color: colors.text['contrast-primary'],
  _hover: {
    backgroundColor: colors.background['error-hover'],
  },
  _active: {
    backgroundColor: colors.background['error-active'],
  },
})

const fdDarkOutline = defineStyle({
  color: colors.text['contrast-secondary'],
  border: '1px solid',
  borderColor: colors.border.primary,
  _hover: {
    color: colors.text.warning,
  },
})

const fdDarkPrimary = defineStyle({
  color: colors.text['contrast-secondary'],
  backgroundColor: colors.background['info-active'],
})

const fdDarkHollow = defineStyle({
  border: 0,
  color: colors.text['contrast-secondary'],
  _hover: {
    color: colors.background.accent['yellow-quaternary'],
  },
})

const fdDarkSaveStar = defineStyle({
  border: 0,
  color: colors.text['contrast-secondary'],
  _hover: {
    backgroundColor: colors.background['contrast-active'],
  },
})

const fdDarkDestructive = defineStyle({
  color: colors.text['contrast-secondary'],
  backgroundColor: colors.background['error-active'],
})

const sizes = {
  xs: defineStyle({
    h: size.xs,
    paddingX: spacing['5xs'],
    paddingY: spacing.none,
  }),
  sm: defineStyle({
    h: size.sm,
    paddingX: spacing['4xs'],
    paddingY: spacing['6xs'],
  }),
  md: defineStyle({
    h: size.md,
    paddingX: spacing['3xs'],
    paddingY: spacing['5xs'],
  }),
  lg: defineStyle({
    h: size.lg,
    paddingX: spacing.xs,
    paddingY: spacing['4xs'],
  }),
  xsIconBtn: defineStyle({
    h: size.xs,
    w: size.xs,
  }),
  smIconBtn: defineStyle({
    h: size.sm,
    w: size.sm,
  }),
  mdIconBtn: defineStyle({
    h: size.md,
    w: size.md,
  }),
  lgIconBtn: defineStyle({
    h: size.lg,
    w: size.lg,
  }),
}

const buttonTheme = defineStyleConfig({
  baseStyle,
  sizes,
  variants: {
    primary,
    secondary,
    hollow,
    outline,
    distractive,
    fdDarkOutline,
    fdDarkPrimary,
    fdDarkHollow,
    fdDarkSaveStar,
    fdDarkDestructive,
  },
  defaultProps: {
    variant: 'secondary',
    size: 'md',
  },
})

export default buttonTheme
